import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import ForumIcon from '@mui/icons-material/Forum';
import { Chip, ChipProps } from '@mui/material';
import { DocumentStatus } from '../../documentsApi';
import { DocumentStatusLabel } from '../../DocumentStatusLabel';

type Props = {
    status?: string | null;
    size?: ChipProps['size'];
    variant?: ChipProps['variant'];
};

const getStatusIcon = (status: DocumentStatus) => {
    switch (status) {
        case 'E':
            return <CloudDownloadIcon fontSize="small" />;
        case 'ID':
            return <ForumIcon fontSize="small" />;
        case 'F':
            return <CheckCircleIcon fontSize="small" />;
        default:
            return undefined;
    }
};

const getStatusColor = (status: DocumentStatus) => {
    switch (status) {
        case 'N':
        case 'E':
            return 'info' as const;
        case 'F':
        case 'A':
        case 'P':
            return 'success' as const;
        case 'O':
        case 'I':
            return 'warning' as const;
        case 'R':
        case 'C':
            return 'error' as const;
        case 'ID':
            return 'error' as const;
        default:
            return 'default' as const;
    }
};

export const ImportedDocumentStatusChip = ({
    status,
    size = 'small',
    variant = 'filled',
}: Props) => {
    const resolvedStatus = (status ?? 'E') as DocumentStatus;

    return (
        <Chip
            icon={getStatusIcon(resolvedStatus)}
            label={<DocumentStatusLabel status={resolvedStatus} />}
            color={getStatusColor(resolvedStatus)}
            variant={variant}
            size={size}
        />
    );
};